import { APIModel } from '@shared/interfaces';
import { LinkType } from '@/tax/models/link-type.enum';
import { Company } from '@/organisations/models';
import { PersonType } from './person-type.enum';

export class PersonalTaxLink implements APIModel {
    id = -1;
    company = new Company();
    person = PersonType.Owner;
    type?: LinkType;

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.company = data.company ? new Company().deserialize(data.company): new Company();
        this.person = data.person ?? PersonType.Owner;
        this.type = data.type ?? undefined;

        return this;
    }

    serialize(): any {
        return {
            id: this.id,
            company_id: this.company.id,
            person: this.person,
            type: this.type,
        };
    }
}
